document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.mm-product-image-slider')

  sliders.forEach((slider) => {
    const track = slider.querySelector('.mm-product-image-slider__track')
    const prev = slider.querySelector('.mm-product-image-slider__arrow--prev')
    const next = slider.querySelector('.mm-product-image-slider__arrow--next')

    if (!track || !prev || !next) return

    const scrollToSlide = (direction) => {
      const slideWidth = track.clientWidth

      track.scrollBy({
        left: direction * slideWidth,
        behavior: 'smooth',
      })
    }

    prev.addEventListener('click', () => scrollToSlide(-1))
    next.addEventListener('click', () => scrollToSlide(1))
  })
})